import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/themes", label: "Themes" },
  { to: "/booking", label: "Book" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-cozy-bg/95 backdrop-blur-md shadow-cozy border-b border-cozy-gold/15"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_teepee-magic-nights/artifacts/g1w0mtsx_the%20cozy%20cove%20logo.jpeg"
            alt="The Cozy Cove"
            className="w-12 h-12 rounded-full object-cover shadow-cozy border border-cozy-gold/20"
          />
          <div className="leading-tight">
            <div className="font-serif text-xl text-cozy-brown">The Cozy Cove</div>
            <div className="font-script text-cozy-gold text-sm -mt-1">magical sleepovers</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? "text-cozy-gold" : "text-cozy-brown hover:text-cozy-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/booking"
            data-testid="nav-cta-book"
            className="px-5 py-2.5 rounded-full bg-cozy-gold text-white text-sm font-medium hover:bg-cozy-gold-dark transition-all shadow-cozy"
          >
            Book Your Party
          </Link>
        </nav>

        <button
          className="lg:hidden p-2 rounded-full bg-white/70 backdrop-blur shadow-cozy"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5 text-cozy-brown" /> : <Menu className="w-5 h-5 text-cozy-brown" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-cozy-bg border-t border-cozy-gold/15 px-5 py-6 space-y-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `block text-lg font-serif ${isActive ? "text-cozy-gold" : "text-cozy-brown"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/booking"
            data-testid="nav-mobile-cta-book"
            className="inline-block mt-2 px-6 py-3 rounded-full bg-cozy-gold text-white font-medium shadow-cozy"
          >
            Book Your Party
          </Link>
        </div>
      )}
    </header>
  );
}
